import { render } from "./MemberDirectory.vue?vue&type=template&id=38cb411d&scoped=true"
import script from "./MemberDirectory.vue?vue&type=script&lang=js"
export * from "./MemberDirectory.vue?vue&type=script&lang=js"

import "./MemberDirectory.vue?vue&type=style&index=0&id=38cb411d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cb411d"]])

export default __exports__